import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Select, Card, Divider, Modal, message, Form, Button, Skeleton, } from 'antd';
import { FaHiking, FaCheckCircle, FaShare, FaExchangeAlt, FaCheck, FaPhoneAlt, FaWhatsapp } from 'react-icons/fa';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { getHotelEnquiry } from '../../../services/flight/flightServices';
import { getfilteredCountries, getImageUrl } from '../../../utils/Constants';
import moment from 'moment';
import { no_images } from '../../../utils/ImagePath';
import Seo from './../../helmet/Helmet'
import BookingRequestModal from './BookingRequestModal';

import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { Fancybox } from "@fancyapps/ui";
import imageConfig from '../../../config/imageConfig';
import { useNavigate } from 'react-router-dom';
import ThankYouModal from './ThankYouModal';
import ShareModalComponent from '../packagepage/ShareModalComponent';


const PackageDetails = ({ packageData, loading }) => {

    const [isBookingRequestModalOpen, setIsBookingRequestModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isThankYouModalOpen, setThankYouModalOpen] = useState(false);
    const [activeDivId, setActiveDivId] = useState('');
    const [isModalOpenShare, setIsModalOpenShare] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const itineraryRef = useRef(null);
    const inclusionRef = useRef(null);
    const descriptionRef = useRef(null);
    const howToBookRef = useRef(null);

    const handleClick = (id) => {
        setActiveDivId(id);

        const sectionRefs = {
            itin: itineraryRef,
            inclu: inclusionRef,
            descri: descriptionRef,
            how: howToBookRef,
        };

        const selectedRef = sectionRefs[id];

        if (selectedRef?.current) {
            selectedRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setTimeout(() => {
                window.scrollTo({
                    top: window.scrollY - 205,
                    behavior: 'smooth',
                });
            }, 300);
        }
    };
    const { itineraries, } = packageData;

    const galleryOptions = {
        showFullscreenButton: true,
        showPlayButton: true,
        autoPlay: false,
        slideInterval: 2000,
    };
    const xlImages = packageData?.package_gallery || [];

    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();

    const handleSubmit = async (values) => {
        setIsLoading(true);

        try {
            const payload = {
                name: values.name,
                email: values.email,
                mobile_number: values.mobile.toString(),
                message_content: values.message,
                enquiry_type: "PACKAGE",
                package_id: packageData?.id,
                no_of_adult: values?.no_of_adult,
                no_of_children: values?.no_of_children,
                country: values.country,
                state: values.state,
                city: values.city,
                date_of_travel: moment(values.date_of_travel).format("YYYY-MM-DD"),
            };

            const response = await getHotelEnquiry(payload);
            setThankYouModalOpen(true)
            setIsBookingRequestModalOpen(false)
            form.resetFields();
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const currentDate = moment();
    const packageValidity = moment(packageData?.package_validity);
    const validityDate = new Date(packageData?.package_validity);
    const isExpired = validityDate < currentDate;

    useEffect(() => {
        Fancybox.bind("[data-fancybox]", {
            Thumbs: false,
            Toolbar: true,
        });

        return () => {
            Fancybox.destroy();
        };
    }, [packageData.package_gallery]);

    return (
        <>
            <Seo
                title={packageData?.meta_title}
                description={packageData?.meta_description}
                link={window.location.href}
                keywords={packageData?.meta_keyword}
                largeTwitterCard={true}
                addPostfixTitle={false}
                noIndex={true}
            />
            {contextHolder}
            <section className='bg-white py-2 sticky border-top'>
                <div className='container'>
                    <Row gutter={16}>
                        <Col md={12} xs={24}>
                            <h2 className='mb-1'>{packageData.package_name}</h2>
                            <p className='d-flex align-items-center '>
                                <div className="border rounded px-1 d-flex align-items-center  me-2">
                                    <svg width="1em" height="1em" viewBox="-1.5 0 15 15" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill="#000000" fillRule="evenodd" d="M574,120 C575.324428,120 580,114.054994 580,110.833333 C580,107.611672 577.313708,105 574,105 C570.686292,105 568,107.611672 568,110.833333 C568,114.054994 572.675572,120 574,120 Z M574,113.333333 C575.420161,113.333333 576.571429,112.214045 576.571429,110.833333 C576.571429,109.452621 575.420161,108.333333 574,108.333333 C572.579839,108.333333 571.428571,109.452621 571.428571,110.833333 C571.428571,112.214045 572.579839,113.333333 574,113.333333 Z" transform="translate(-568 -105)"></path> </g></svg>
                                    <ul className="location-list d-flex align-items-center ">
                                        <li><a href="">{packageData.package_country}</a></li>
                                        <FaExchangeAlt className="mx-2" />
                                        <li>{packageData.package_destination}</li>
                                    </ul>
                                </div>
                                <small className="border rounded px-1 py-1 fw-bold lh-sm  me-2">{`${packageData?.package_duration || 0}D/${(packageData?.package_duration || 0) - 1}N`}</small>

                                <small className="border rounded px-1 py-1 fw-bold lh-sm mt-2 d-none">{packageData?.package_hotel}</small>
                            </p>
                        </Col>
                    </Row>
                </div>
            </section>

            <section className="container-fluid holiday_confirm mb-4">
                <div className='bg-white holiday_confirm py-1'>
                    <div className='container'>
                        <Row gutter={16} className='hotel_confirm_images'>
                            <Col md={12} xs={24} className='d-none d-md-block'>
                                {loading ? (
                                    <Skeleton.Image active className="w-100" style={{ height: '435px' }} />
                                ) : (
                                    <a data-fancybox="dynamic-gallery" href={getImageUrl(packageData.package_gallery?.[0], 'GALLERY')}>
                                        <img loading="lazy" src={getImageUrl(packageData.package_gallery?.[0], 'GALLERY')}
                                            className="img-fluid rounded"
                                        />
                                    </a>
                                )}
                            </Col>

                            <Col md={6} xs={24} className='d-none d-md-block'>
                                {loading ? (
                                    <Skeleton.Image active={true} className='w-100 mb-2' style={{ height: "210px" }} />
                                ) : (
                                    <a data-fancybox="dynamic-gallery" href={getImageUrl(packageData?.package_gallery?.[1], 'GALLERY')}>
                                        <img loading="lazy" src={getImageUrl(packageData?.package_gallery?.[1], 'GALLERY')} alt='Room' className="img-fluid rounded" />
                                    </a>)}

                                {loading ? (
                                    <Skeleton.Image active={true} className='w-100 mb-2' style={{ height: "210px" }} />
                                ) : (
                                    <a data-fancybox="dynamic-gallery" href={getImageUrl(packageData?.package_gallery?.[2], "GALLERY")}>
                                        <img loading="lazy" src={getImageUrl(packageData?.package_gallery?.[2], "GALLERY")} alt='Building' className="img-fluid rounded" />
                                    </a>)}
                            </Col>
                            <Col md={6} xs={24}>
                                {loading ? (
                                    <Skeleton.Image active={true} className='w-100 mb-2' style={{ height: "210px" }} />
                                ) : (<a data-fancybox="dynamic-gallery" href={getImageUrl(packageData?.package_gallery?.[3], "GALLERY")}>
                                    <img loading="lazy" src={getImageUrl(packageData?.package_gallery?.[3], "GALLERY")} alt='Rooms' className="img-fluid rounded  d-none d-md-inline" />
                                </a>)}

                                <div className='more_photos position-relative'>
                                    {loading ? (
                                        <Skeleton.Image active={true} className='w-100 mb-2' style={{ height: "210px" }} />
                                    ) : (
                                        <>
                                            <a data-fancybox="dynamic-gallery" href={getImageUrl(packageData?.package_gallery?.[4], "GALLERY")}>
                                                <img loading="lazy" src={getImageUrl(packageData?.package_gallery?.[4], "GALLERY")} alt='Garden' className="img-fluid rounded" />
                                            </a>
                                            <a
                                                href="javascript:void(0)"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    Fancybox.show(
                                                        packageData?.package_gallery?.map((image, index) => ({
                                                            src: getImageUrl(image, "GALLERY"),
                                                            thumb: getImageUrl(image, "GALLERY")
                                                        })),

                                                        { startIndex: 0 }
                                                    );
                                                }}
                                                className='position-absolute see-more-btn'
                                            >
                                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18.5116 10.0767C18.5116 10.8153 17.8869 11.4142 17.1163 11.4142C16.3457 11.4142 15.7209 10.8153 15.7209 10.0767C15.7209 9.33801 16.3457 8.7392 17.1163 8.7392C17.8869 8.7392 18.5116 9.33801 18.5116 10.0767Z" fill="#ffffff"></path> <path fillRule="evenodd" clipRule="evenodd" d="M18.0363 5.53205C16.9766 5.39548 15.6225 5.39549 13.9129 5.39551H10.0871C8.37751 5.39549 7.02343 5.39548 5.9637 5.53205C4.87308 5.6726 3.99033 5.96873 3.29418 6.63601C2.59803 7.30329 2.28908 8.14942 2.14245 9.19481C1.99997 10.2106 1.99999 11.5085 2 13.1472V13.2478C1.99999 14.8864 1.99997 16.1843 2.14245 17.2001C2.28908 18.2455 2.59803 19.0916 3.29418 19.7589C3.99033 20.4262 4.87307 20.7223 5.9637 20.8629C7.02344 20.9994 8.37751 20.9994 10.0871 20.9994H13.9129C15.6225 20.9994 16.9766 20.9994 18.0363 20.8629C19.1269 20.7223 20.0097 20.4262 20.7058 19.7589C21.402 19.0916 21.7109 18.2455 21.8575 17.2001C22 16.1843 22 14.8864 22 13.2478V13.1472C22 11.5085 22 10.2106 21.8575 9.19481C21.7109 8.14942 21.402 7.30329 20.7058 6.63601C20.0097 5.96873 19.1269 5.6726 18.0363 5.53205ZM6.14963 6.8576C5.21373 6.97821 4.67452 7.2044 4.28084 7.58175C3.88716 7.95911 3.65119 8.47595 3.52536 9.37303C3.42443 10.0926 3.40184 10.9919 3.3968 12.1682L3.86764 11.7733C4.99175 10.8305 6.68596 10.8846 7.74215 11.897L11.7326 15.7219C12.1321 16.1049 12.7611 16.1571 13.2234 15.8457L13.5008 15.6589C14.8313 14.7626 16.6314 14.8664 17.8402 15.9092L20.2479 17.9862C20.3463 17.7222 20.4206 17.4071 20.4746 17.0219C20.6032 16.1056 20.6047 14.8977 20.6047 13.1975C20.6047 11.4972 20.6032 10.2893 20.4746 9.37303C20.3488 8.47595 20.1128 7.95911 19.7192 7.58175C19.3255 7.2044 18.7863 6.97821 17.8504 6.8576C16.8944 6.73441 15.6343 6.73298 13.8605 6.73298H10.1395C8.36575 6.73298 7.10559 6.73441 6.14963 6.8576Z" fill="#ffffff"></path> <g opacity="0.5"> <path d="M17.0866 2.61039C16.2268 2.49997 15.1321 2.49998 13.7675 2.5H10.6778C9.31314 2.49998 8.21844 2.49997 7.35863 2.61039C6.46826 2.72473 5.72591 2.96835 5.13712 3.53075C4.79755 3.8551 4.56886 4.22833 4.41309 4.64928C4.91729 4.41928 5.48734 4.28374 6.12735 4.20084C7.21173 4.06037 8.5973 4.06038 10.3466 4.06039H14.2615C16.0108 4.06038 17.3963 4.06037 18.4807 4.20084C19.0397 4.27325 19.5453 4.38581 20.0003 4.56638C19.8457 4.17917 19.6253 3.83365 19.3081 3.53075C18.7193 2.96835 17.977 2.72473 17.0866 2.61039Z" fill="#ffffff"></path> </g> </g></svg>
                                                See more photos
                                            </a>
                                        </>
                                    )}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                {/* Tabs Section */}
                <section className='HC-tabs mb-3'>
                    <div className='container'>
                        <Row gutter={16}>
                            <Col xs={24}>
                                <div className='d-md-flex align-items-center justify-content-between'>
                                    <div className="tab-buttons">
                                        <ul>
                                            <li className={activeDivId === 'itin' ? 'active' : ''}>
                                                <a onClick={() => handleClick('itin')} href="#itinerary">Itinerary</a>
                                            </li>
                                            <li className={activeDivId === 'inclu' ? 'active' : ''}>
                                                <a onClick={() => handleClick('inclu')} href="#inclusion">Inclusions/Exclusions</a>
                                            </li>
                                            <li className={activeDivId === 'descri' ? 'active' : ''}>
                                                <a onClick={() => handleClick('descri')} href="#Description">Description</a>
                                            </li>
                                            <li className={activeDivId === 'how' ? 'active' : ''}>
                                                <a onClick={() => handleClick('how')} href="#HowToBook">How to Book</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <a className='d-md-block d-none' onClick={() => setIsModalOpenShare(true)}><FaShare className='me-1' /> Share</a>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>

                <div className='container'>
                    <Row gutter={16}>
                        <Col md={17}>
                            <Card className="card mb-md-2 holiday_confirm_cntr d-md-none">
                                <h2 className='mb-1 fw-bold'>₹{Math.round(packageData?.package_price)} /Adult</h2>
                                <h6 className='mb-2'>Excluding applicable taxes</h6>
                                <Button onClick={() => setIsBookingRequestModalOpen(true)} className='btn btn-primary w-100 text-center' aria-label="Enquire now">Enquire Now</Button>
                            </Card>

                            <div id={activeDivId} className="days_activity_cntr pb-1">
                                {/* Itinerary Tab */}
                                <div ref={itineraryRef} id='itinerary' className='itinerary'>
                                    {itineraries?.map((itinerary) => (
                                        <Card className="card mb-md-2" key={itinerary.id}>
                                            <Row gutter={16}>
                                                <Col md={24} xs={24}>
                                                    <div id="Place" className="days_activity mb-2">
                                                        <div className="activity_heading_cntr d-md-flex align-items-center justify-content-between">
                                                            <h4>{`Day ${itinerary.package_day_no}`}</h4>
                                                            <small className="d-flex align-items-center gap-2 lh-sm">INCLUDED: <FaHiking /> 1 Activity</small>
                                                        </div>

                                                        <Row gutter={16} className="mt-3 px-md-2">
                                                            <Col md={24}>
                                                                <div className="mb-2 d-md-flex align-items-center gap-4">
                                                                    <p className="mb-2 mb-md-0 fw-bold">
                                                                        <svg fill="#000000" height="20px" width="20px" version="1.2" baseProfile="tiny" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path id="XMLID_3_" d="M198.5,127h56.8c-3.1,51.4-36.3,94.5-82.3,111.7V256H83v-17.3C37,221.5,3.8,178.4,0.7,127h155.1l87.5-68.1 c3.5-2.7,8.5-2.1,11.2,1.4s2.1,8.5-1.4,11.2c-0.1,0.1-0.3,0.2-0.4,0.3l-81,55.1l73-36.2c4-2,8.8-0.3,10.7,3.6c2,4,0.3,8.8-3.6,10.7 c-0.2,0.1-0.3,0.2-0.5,0.2L198.5,127z M163.6,79.4c0,7.8,3.2,12,5.7,15.3c0.7,1,1.4,1.9,2,2.8c0.9,1.4,2.3,2.1,3.8,2.1 c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-0.8-1.3-1.7-2.4-2.5-3.5c-2.2-3-3.9-5.1-3.9-9.9c0-4.8,1.6-6.9,3.9-9.9 c2.5-3.3,5.7-7.5,5.7-15.3s-3.2-12-5.7-15.3l-0.5-0.6c-1.5-2-4.3-2.4-6.3-0.9c-2,1.5-2.4,4.3-0.9,6.3l0.5,0.6c2.2,3,3.9,5.1,3.9,9.9 c0,4.8-1.6,6.9-3.9,9.9C166.7,67.4,163.6,71.6,163.6,79.4z M115.7,71c0,11.2,4.4,16.9,8.3,22c1.2,1.5,2.2,2.9,3.2,4.5 c0.9,1.4,2.3,2.1,3.8,2.1c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-1.2-1.9-2.5-3.6-3.7-5.2c-3.4-4.5-6.4-8.4-6.4-16.5 s3-12,6.4-16.5c3.9-5.1,8.3-10.8,8.3-22c0-11.1-4.4-16.9-8.3-22l-0.7-0.9c-1.5-2-4.3-2.4-6.3-0.9c-2,1.5-2.4,4.3-0.9,6.3l0.7,1 c3.4,4.5,6.4,8.4,6.4,16.5c0,8.1-3,12-6.4,16.5C120.1,54.1,115.7,59.9,115.7,71z M72.9,79.4c0,7.8,3.2,12,5.7,15.3 c0.7,1,1.4,1.9,2,2.8c0.9,1.4,2.3,2.1,3.8,2.1c0.8,0,1.6-0.2,2.4-0.7c2.1-1.3,2.8-4.1,1.5-6.2c-0.8-1.3-1.7-2.4-2.5-3.5 c-2.2-3-3.9-5.1-3.9-9.9c0-4.8,1.6-6.9,3.9-9.9c2.5-3.3,5.7-7.5,5.7-15.3c0-7.8-3.2-12-5.7-15.3l-0.5-0.6c-1.5-2-4.3-2.4-6.3-0.9 c-2,1.5-2.4,4.3-0.9,6.3l0.5,0.6c2.2,3,3.9,5.1,3.9,9.9c0,4.8-1.6,6.9-3.9,9.9C76.1,67.4,72.9,71.6,72.9,79.4z"></path> </g></svg>
                                                                        Day Meals</p>
                                                                    <div className='d-flex justify-content-between align-items-center'>
                                                                        {itinerary?.is_meal && (
                                                                            <p><FaCheckCircle /> <b>Meal</b></p>
                                                                        )}
                                                                        {itinerary?.is_breakfast && (
                                                                            <p><FaCheckCircle /> <b>Breakfast</b></p>
                                                                        )}
                                                                        {itinerary?.is_lunch && (
                                                                            <p><FaCheckCircle className='me-2' /> <b className='me-2'>Lunch</b></p>
                                                                        )}
                                                                        {itinerary?.is_dinner && (
                                                                            <p><FaCheckCircle className='ms-2' /> <b className='me-2'>Dinner</b></p>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        <Row gutter={16}>
                                                            <Col xs={24} md={10}>
                                                                <img
                                                                    src={getImageUrl(itinerary.package_photo, "ITERNARY")}
                                                                    alt="Activity"
                                                                    className="img-fluid rounded"
                                                                />
                                                            </Col>
                                                            <Col xs={24} md={14}>
                                                                {/* <div className="text-dark fw-bold">{packageData.package_name}</div> */}
                                                                <p dangerouslySetInnerHTML={{ __html: itinerary.package_itinerary }} />
                                                            </Col>
                                                        </Row>

                                                        <Divider className="my-2" />

                                                        <Row gutter={16}>
                                                            <Col md={24}>
                                                                <div className="bg-light-success px-2 py-1 rounded text-center">
                                                                    <p><b>End Of Day</b></p>
                                                                    {/* <p><b>End Of Day</b> - Spend time at Leisure or add an activity to your day</p> */}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    ))}
                                </div>

                                {/* Inclusions/Exclusions Tab */}
                                <div ref={inclusionRef} id='inclusion' className='mt-2 inclusion'>
                                    <Card>
                                        <div>
                                            <h4 className='mb-2'>Inclusions</h4>
                                            <div dangerouslySetInnerHTML={{ __html: packageData.package_inclusions }} />
                                            <h4 className='mb-2'>Exclusions</h4>
                                            <div dangerouslySetInnerHTML={{ __html: packageData.package_exclusions }} />
                                        </div>

                                    </Card>
                                </div>

                                {/* Description Tab */}
                                <div ref={descriptionRef} id='Description' className='mt-2 Description'>
                                    <Card>
                                        <div>

                                            <h4 className='mb-2'>Package Description</h4>
                                            <div dangerouslySetInnerHTML={{ __html: packageData.package_description }} />
                                        </div>
                                    </Card>
                                </div>

                                {/* How to Book Tab */}
                                <div ref={howToBookRef} id='HowToBook' className='mt-2 HowToBook'>
                                    <Card>
                                        <div>
                                            <h4 className='mb-2'>How to Book</h4>
                                            {/* <p>{packageData.package_how_to_book}</p> */}
                                            <div dangerouslySetInnerHTML={{ __html: packageData.package_how_to_book }} />
                                        </div>
                                    </Card>
                                </div>

                            </div>
                        </Col>
                        <Col md={7} xs={24}>
                            <Card className="card mb-md-2 holiday_confirm_cntr d-none d-md-block">
                                <div>
                                    <h2 className='mb-1 fw-bold'>₹{Math.round(packageData?.package_price)} /Adult</h2>
                                    <h6 className='mb-2'>Excluding applicable taxes</h6>
                                    {!isExpired && <div className='bg bg-light-danger d-flex align-items-center p-2 mb-2 gap-1 rounded'>
                                        <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="1.25rem" height="1.25rem" viewBox="0 0 123.996 123.996" xmlSpace="preserve"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M9.821,118.048h104.4c7.3,0,12-7.7,8.7-14.2l-52.2-92.5c-3.601-7.199-13.9-7.199-17.5,0l-52.2,92.5 C-2.179,110.348,2.521,118.048,9.821,118.048z M70.222,96.548c0,4.8-3.5,8.5-8.5,8.5s-8.5-3.7-8.5-8.5v-0.2c0-4.8,3.5-8.5,8.5-8.5 s8.5,3.7,8.5,8.5V96.548z M57.121,34.048h9.801c2.699,0,4.3,2.3,4,5.2l-4.301,37.6c-0.3,2.7-2.1,4.4-4.6,4.4s-4.3-1.7-4.6-4.4 l-4.301-37.6C52.821,36.348,54.422,34.048,57.121,34.048z"></path> </g> </g></svg>

                                        <h4 className=''> Validity: {moment(packageData?.package_validity).format('DD MMM, YYYY')}</h4>
                                    </div>
                                    }
                                    <Button onClick={() => setIsBookingRequestModalOpen(true)} className='btn btn-primary w-100 text-center' aria-label="Enquire now">Enquire Now</Button>
                                </div>
                            </Card>

                            <BookingRequestModal
                                isOpen={isBookingRequestModalOpen}
                                onOk={() => setIsBookingRequestModalOpen(false)}
                                onCancel={() => setIsBookingRequestModalOpen(false)}
                                onSubmit={handleSubmit}
                                isLoading={isLoading}
                                packageValidity={packageValidity}
                                form={form}
                                getfilteredCountries={getfilteredCountries}
                                currentDate={currentDate}
                                isExpired={isExpired}
                            />

                        </Col>
                    </Row>
                </div>

            </section>

            <div className='hotel-gallery'>
                <Modal
                    className='Gallery_cntr p-0'
                    open={isModalOpen}
                    footer={null}
                    onCancel={() => setIsModalOpen(false)}
                    centered
                    width={1000}
                    destroyOnClose={true}
                >
                    <div className="gallery-container">
                        <ImageGallery
                            items={xlImages.map(img => {
                                const baseUrl = imageConfig.ORIGINAL_IMAGE_URL;
                                const imageUrl = img?.image_url?.startsWith('https')
                                    ? img.image_url
                                    : img?.image_url
                                        ? `${baseUrl}${img.image_url}`
                                        : no_images;
                                return {
                                    original: imageUrl,
                                    thumbnail: imageUrl,
                                    fullscreen: imageUrl
                                };
                            })}
                            showThumbnails={true}
                            showBullets={true}
                            {...galleryOptions}
                        />
                    </div>
                </Modal>
            </div>

            <ThankYouModal
                isOpen={isThankYouModalOpen}
                setThankYouModalOpen={setThankYouModalOpen}
            />

            <ShareModalComponent
                isModalOpenShare={isModalOpenShare}
                setIsModalOpenShare={setIsModalOpenShare}
            />

        </>
    );
};

export default PackageDetails;

